<template>
  <div id="add-new-order-modal">
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="cancelOrderModal"
        persistent
        max-width="530px"
      >
        <v-card>
          <form
            action=""
            @submit.prevent="submitForm()"
          >
            <v-card-title>
              <v-flex
                xs11
                sm11
                md11
              ><span class="headline">Cancel Order</span></v-flex>
              <v-flex
                xs1
                sm1
                md1
              >
                <v-btn
                  flat
                  @click="closeCancelingOrderModal(), $validator.reset()"
                  class="close"
                >&times;</v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert
                type="success"
                :value="cancelAlert"
              >
                Order canceled successfully
              </v-alert>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    label="Cancel reason*"
                    v-model="cancelData.cancel_reason"
                    :error-messages="errors.collect('Cancel reason')"
                    v-validate="'required'"
                    data-vv-name="Cancel reason"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeCancelingOrderModal(), $validator.reset()"
                outline
                color="normal"
              >Close</v-btn>
              <v-btn
                type="submit"
                style="height:auto; margin-right: 4%"
                outline
                color="success"
              >Save</v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: [
    'cancelOrderModal',
    'closeCancelingOrderModal',
    'cancelAlert',
    'cancelData',
    'cancelingOrder'
  ],

  methods: {
    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.cancelingOrder()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/adminCancelOrder.vue